import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useNotifications } from '../hooks/useNotifications';
import './NotificationCenter.css';

function NotificationCenter() {
  const { currentUser } = useAuth();
  const { notifications, unreadCount, deleteNotification } = useNotifications();
  const [showPanel, setShowPanel] = useState(false);
  const [selectedNotif, setSelectedNotif] = useState(null);
  const location = useLocation();

  const togglePanel = () => {
    if (!showPanel) {
      localStorage.setItem('notif_last_seen', Date.now());
    }
    setShowPanel(!showPanel);
  };

  useEffect(() => {
    const handleToggle = () => togglePanel();
    window.addEventListener('toggle-notif-panel', handleToggle);
    return () => window.removeEventListener('toggle-notif-panel', handleToggle);
  }, [showPanel]);

  // Hide Notification Icon on Embed and Resume routes
  if (location.pathname.startsWith('/embed') || location.pathname.startsWith('/resume')) {
    return null;
  }

  const handleDismiss = async (e, id) => {
    e.stopPropagation();
    await deleteNotification(id);
  };

  if (!currentUser) return null;

  return (
    <div className="notification-center-wrapper">
      <button className={`notif-bell-btn ${unreadCount > 0 ? 'has-unread' : ''}`} onClick={togglePanel}>
        <i className="fa-solid fa-bell"></i>
        {unreadCount > 0 && <span className="unread-dot">{unreadCount}</span>}
      </button>

      {showPanel && (
        <div className="notif-panel glass-card">
          <div className="notif-panel-header">
            <h3>Notifications</h3>
            <button onClick={() => setShowPanel(false)}><i className="fa-solid fa-xmark"></i></button>
          </div>
          
          <div className="notif-panel-body">
            {notifications.length === 0 ? (
              <div className="notif-empty">
                <i className="fa-solid fa-envelope-open"></i>
                <p>You're all caught up!</p>
              </div>
            ) : (
              notifications.map(n => {
                let iconClass = "fa-circle-info";
                if (n.type === 'success') iconClass = "fa-circle-check";
                if (n.type === 'warning') iconClass = "fa-triangle-exclamation";
                if (n.type === 'critical' || n.type === 'danger') iconClass = "fa-circle-exclamation";

                return (
                  <div 
                    key={n.notificationId} 
                    className={`notif-card theme-${n.type}`}
                    onClick={() => {
                        setSelectedNotif(n);
                        setShowPanel(false);
                        localStorage.setItem('notif_last_seen', Date.now());
                    }}
                    style={{cursor: 'pointer'}}
                  >
                    <div className="notif-card-header">
                      <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                        <i className={`fa-solid ${iconClass} notif-type-icon`}></i>
                        <strong>{n.title}</strong>
                      </div>
                      <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                        <span className="notif-time">{new Date(n.createdAt).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
                        <button className="notif-dismiss-btn" onClick={(e) => handleDismiss(e, n.notificationId)}>
                          <i className="fa-solid fa-xmark"></i>
                        </button>
                      </div>
                    </div>
                    <p>{n.message}</p>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}

      {/* MAIL MODAL POPUP */}
      {selectedNotif && (
        <div className="notif-mail-overlay" onClick={() => setSelectedNotif(null)}>
          <div className={`notif-mail-modal glass-card theme-${selectedNotif.type}`} onClick={e => e.stopPropagation()}>
            <div className="mail-modal-header">
              <div className="mail-meta">
                <span className="mail-from">System Broadcast // DevTracker Core</span>
                <span className="mail-date">{new Date(selectedNotif.createdAt).toLocaleString()}</span>
              </div>
              <button className="mail-close-btn" onClick={() => setSelectedNotif(null)}>
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            
            <div className="mail-content">
              <div className="mail-subject">
                <i className={`fa-solid ${
                  selectedNotif.type === 'success' ? 'fa-circle-check' : 
                  selectedNotif.type === 'warning' ? 'fa-triangle-exclamation' :
                  selectedNotif.type === 'critical' ? 'fa-circle-exclamation' : 'fa-circle-info'
                } type-icon`}></i>
                <h2>{selectedNotif.title}</h2>
              </div>
              <div className="mail-body">
                {selectedNotif.message}
              </div>
            </div>

            <div className="mail-footer">
              <button className="mail-action-btn delete" onClick={() => {
                deleteNotification(selectedNotif.notificationId);
                setSelectedNotif(null);
              }}>
                <i className="fa-solid fa-trash-can"></i> DISCARD MESSAGE
              </button>
              <button className="mail-action-btn close" onClick={() => setSelectedNotif(null)}>
                ACKNOWLEDGE
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default NotificationCenter;
